module.exports = __webpack_public_path__ + "img/P1270281.9a67c50d.jpg";